'use client';

import type { LocaleType, UriType } from '~/model/GlobalTypes';
import { VpButton } from '@vtmn-play/react/headless';
import { useTranslations } from 'next-intl';
import { useActiveThemeMode } from '~/hooks/useActiveThemeMode';
import { ThemeType } from '~/model/GlobalTypes';
import { AiIconForDarkMode } from './AiIconForDarkMode';
import { AiIconForLightMode } from './AiIconForLightMode';
import { TranslationRating } from './TranslationRating';

export const Translate = ({
  getTranslation,
  originalLanguage,
  userLanguage,
  translated,
  entityUri,
  isValidTranslated,
  isEnTranslationValid,
  fromComment,
}: {
  getTranslation: (locale?: LocaleType) => void;
  originalLanguage: LocaleType;
  userLanguage: LocaleType;
  translated: boolean;
  entityUri: UriType;
  isValidTranslated?: boolean;
  isEnTranslationValid?: boolean;
  fromComment?: boolean;
}) => {
  const t = useTranslations('GLOBAL');
  const tLanguage = useTranslations('global.language');
  const { activeThemeMode } = useActiveThemeMode();

  const shouldDisplay = (userLanguage !== originalLanguage && !isValidTranslated) || translated;

  return shouldDisplay
    ? (
        <section
          className="translate"
          data-testid="translate"
          data-theme-mode={activeThemeMode}
        >
          <div className="translate__ai-icon">
            {activeThemeMode === ThemeType.light ? <AiIconForLightMode /> : <AiIconForDarkMode />}
          </div>
          {!translated && (
            <span className="vp-body-s translate__label">
              {t('TRANSLATE.WITH_LLM')}
            </span>
          )}
          <span className="translate__separator" />
          <div className="translate-button">
            <VpButton
              className="translate__action"
              data-cy="translateButton"
              data-testid="translateButton"
              variant="tertiary"
              onClick={() => getTranslation()}
            >
              {(fromComment
                && !translated
                && t('TRANSLATE.ACTION', {
                  language: tLanguage(userLanguage),
                }))
                || (fromComment && translated && t('ORIGINAL_LABEL'))
                || (translated && t('TRANSLATE.ACTION', {
                  language: tLanguage(userLanguage),
                }))
                || (isEnTranslationValid && t('TRANSLATE_EN'))
                || t('ORIGINAL_LABEL')}
            </VpButton>
          </div>
          {!fromComment && (
            <>
              <span className="translate__separator" />
              <TranslationRating entityUri={entityUri} />
            </>
          )}
        </section>
      )
    : null;
};
